<template>
    <div class="header-item">
        <h4 class="header-item-title">
            {{ name }}
        </h4>
        <div class="header-filters">
            <list-header-sort v-if="!nonSortable"
                              :is-sorted-by="isSortedBy"
                              :sort-direction="sortDirection"
                              @sort="sort"
            />
        </div>
    </div>
</template>

<script>
    import { mapMutations, mapState, mapActions } from 'vuex';
    import ListHeaderSort from '@/components/controls/list-sort/ListHeaderSort';

    export default {
        name: 'ClientListHeaderItem',
        components: {ListHeaderSort},
        props: ['id', 'name', 'nonSortable'],
        computed: {
            ...mapState('clients', ['listingHeader']),
            isSortedBy() {
                return this.listingHeader.sorting.targetId === this.id;
            },
            sortDirection() {
                return this.listingHeader.sorting.direction;
            },
        },
        methods: {
            ...mapMutations('clients', ['setSortingDirection', 'setSortingTargetId']),
            ...mapActions('clients', ['getClients']),
            sort(direction) {
                this.setSortingDirection(direction);
                this.setSortingTargetId(this.id);
                this.getClients();
            },
        },
    };
</script>

<style lang="scss"
       scoped
>
button.v-icon {
    font-size: 18px !important;
}
</style>